var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmpteColorBars16X9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg4163",
    width: 1920,
    height: 1080,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .st0{fill:#666}.st1{fill:#bfbfbf}.st15{fill:#262626}.st16{fill:#fff}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect3394",
    d: "M0 0h1920v1080H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4808",
    d: "M0 0h240v630H0z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4811",
    d: "M240 0h205v630H240z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4839",
    fill: "#bfbf00",
    d: "M445 0h206v630H445z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4841",
    fill: "#00bfbf",
    d: "M651 0h206v630H651z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4843",
    fill: "#00bf00",
    d: "M857 0h206v630H857z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4845",
    fill: "#bf00bf",
    d: "M1063 0h206v630h-206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4847",
    fill: "#bf0000",
    d: "M1269 0h206v630h-206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4849",
    fill: "#0000bf",
    d: "M1475 0h205v630h-205z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4851",
    d: "M1680 0h240v630h-240z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4180",
    fill: "#0ff",
    d: "M0 630h240v90H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4182",
    fill: "#003f69",
    d: "M240 630h205v90H240z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4232",
    d: "M445 630h1235v90H445z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4234",
    fill: "#00f",
    d: "M1680 630h240v90h-240z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4236",
    fill: "#ff0",
    d: "M0 720h240v90H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4238",
    fill: "#410077",
    d: "M240 720h205v90H240z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rect4240_00000078752745385694933880000004285230885311537562_",
    x1: 437.331604,
    x2: 1466.7346191,
    y1: 16067,
    y2: 16067,
    gradientTransform: "matrix(1.00058 0 0 1 7.4147592 -15302)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect4240",
    fill: "url(#rect4240_00000078752745385694933880000004285230885311537562_)",
    d: "M445 720h1030v90H445z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4250",
    fill: "red",
    d: "M1680 720h240v90h-240z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4254",
    d: "M0 810h240v270H0z",
    className: "st15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4256",
    d: "M240 810h309v270H240z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4258",
    d: "M549 810h411v270H549z",
    className: "st16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4260",
    d: "M960 810h171v270H960z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4262",
    d: "M1131 810h69v270h-69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4196",
    d: "M1200 810h68v270h-68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4198",
    fill: "#050505",
    d: "M1268 810h69v270h-69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4200",
    d: "M1337 810h68v270h-68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4202",
    fill: "#0a0a0a",
    d: "M1405 810h69v270h-69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4204",
    d: "M1474 810h206v270h-206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect4206",
    d: "M1680 810h240v270h-240z",
    className: "st15"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect4250_00000025417549005041931040000018246960240555599293_",
    d: "M1475 720h205v90h-205z",
    className: "st16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmpteColorBars16X9);
export default __webpack_public_path__ + "static/media/SMPTE_Color_Bars_16x9.ab11f5eed300bd9408163b17a39f79f0.svg";
export { ForwardRef as ReactComponent };